import { enumify, Enumify } from '@mews/enumify';
import { PaymentRequestReason as PaymentRequestReasonEnum } from './PaymentRequestReason';

function BasePaymentRequestReason() {}
enumify<PaymentRequestReasonEnum, PaymentRequestReasonEnum>(
    BasePaymentRequestReason,
    'PaymentRequestReason',
    PaymentRequestReasonEnum
);

export const PaymentRequestReason = BasePaymentRequestReason as unknown as Enumify<
    PaymentRequestReasonEnum,
    PaymentRequestReasonEnum
>;
